import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh_CN from './langs/zh_CN'
import EN from './langs/EN'

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: localStorage.getItem('ilang') || 'zh_CN',
    messages: {
        zh_CN,
        EN
    },
	silentTranslationWarn: true, // 去除国际化警告
})
export default i18n